module.exports = __webpack_public_path__ + "img/8-WHEEL.7b56c26c.png";